import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from "gatsby"
import React, { useContext } from "react"
import { Container, Form, Nav, Navbar } from "react-bootstrap"
import ThemeContext from "../utils/theme"
import { useTranslation } from "../utils/language"
import "./Fontawesome.js"

export default () => {
  const { dark, toggleDark, toString } = useContext(ThemeContext)
  const { lang, toggleLang, t } = useTranslation()

  return (
    <Navbar variant={toString()} fixed="top" collapseOnSelect expand="md">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <span className="logo">Régis Atemengue</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse
          id="responsive-navbar-nav"
          className="justify-content-end"
        >
          <Nav className="pr-3 mr-4 nav-links">
            <Nav.Link className="ml-2" as={Link} to="/bio" title={t("nav.bio")}>
              {t("nav.bio")}
            </Nav.Link>
            <Nav.Link className="ml-2" as={Link} to="/blog" title={t("nav.blog")}>
              {t("nav.blog")}
            </Nav.Link>
            <Nav.Link className="ml-2" as={Link} to="/formations" title={t("nav.formations")}>
              {t("nav.formations")}
            </Nav.Link>
            <Nav.Link className="ml-2" as={Link} to="/mentor" title={t("nav.mentoring")}>
              {t("nav.mentoring")}
            </Nav.Link>
            <Nav.Link className="ml-2" as={Link} to="/meetup" title={t("nav.meetup")}>
              {t("nav.meetup")}
            </Nav.Link>
            <Nav.Link className="ml-2" as={Link} to="/projets" title={t("nav.projets")}>
              {t("nav.projets")}
            </Nav.Link>
            <Nav.Link className="ml-2" as={Link} to="/cv" title={t("nav.cv")}>
              {t("nav.cv")}
            </Nav.Link>
            <Nav.Link className="ml-2" as={Link} to="/contacts" title={t("nav.contacts")}>
              {t("nav.contacts")}
            </Nav.Link>
            <Nav.Link
              className="ml-2"
              as={Link}
              target="_blank"
              href="https://www.youtube.com/@regisatemengue"
              title="Youtube Channel"
            >
              <FontAwesomeIcon size="xl" icon={["fab", "youtube"]} />
            </Nav.Link>

            {/* Toggle langue */}
            <button
              onClick={toggleLang}
              className="lang-toggle ml-2 my-auto"
              title={lang === "fr" ? "Switch to English" : "Passer en français"}
            >
              {lang === "fr" ? "🇬🇧 EN" : "🇫🇷 FR"}
            </button>

            <Form className="ml-3 my-auto">
              <div className="switch-wrapper">
                <label id="switch" className="switch" htmlFor="checkbox">
                  <input
                    checked={dark}
                    onChange={toggleDark}
                    type="checkbox"
                    id="checkbox"
                  />
                  <div id="slider" className="slider round"></div>
                </label>
              </div>
            </Form>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
